// extracted by mini-css-extract-plugin
export var infoItem = "_u0-2";
export var title = "_u0-0";
export var value = "_u0-1";